import React from 'react';
import Media from '../media';
import Typo from '../typo';
import { IMG_BASE_PATH } from 'utils/constants';
// import { useSelector } from 'react-redux/es/hooks/useSelector';
// import config from "../../common/config";

const TeamDetail = ({ teamName, teamFlag }) => {
  const flagImage = teamFlag
    ? `${IMG_BASE_PATH}images/flags/${teamFlag}.png`
    : `${IMG_BASE_PATH}images/flags/0.png`;

  return (
    <div className='si-teamDetail'>
      {teamName && (
        <Typo transKey={'team_name'} component='h5' className='si-teamDetail-name'>
          {teamName}
        </Typo>
      )}
      <div className='si-teamDetail-flag'>
        <Media
          imgSrc={flagImage}
          imgAlt='Team Flag'
          fallback={`${IMG_BASE_PATH}images/flags/0.png`}
        />
      </div>
    </div>
  );
};

export default TeamDetail;
